var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@mui/base/Button";
import React from "react";
import "../../../@common/styles/styles.scss";
function TabBody(props) {
    var buttonText = props.buttonText, onButtonClick = props.onButtonClick, bodyText = props.bodyText, dataTestId = props.dataTestId;
    return (_jsxs("div", __assign({ className: "modernization-tab-body", "data-testid": dataTestId }, { children: [_jsx("span", __assign({ className: "modernization-tab-body-text" }, { children: bodyText })), _jsx(Button, __assign({ onClick: function () { return onButtonClick(); }, className: "modernization-tab-body-button", "data-testid": dataTestId + "-button" }, { children: buttonText }))] })));
}
export default TabBody;
